import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/imgs/CollegeSituation/collegeIntroduce/collegeTime.png'
import _imports_1 from '../../../assets/imgs/CollegeSituation/collegeIntroduce/collegeAddress.png'
import _imports_2 from '../../../assets/imgs/CollegeSituation/collegeIntroduce/master.png'
import _imports_3 from '../../../assets/imgs/CollegeSituation/collegeIntroduce/doctor.png'
import _imports_4 from '../../../assets/imgs/qrCode/qrCode1.png'


const _withScopeId = n => (_pushScopeId("data-v-26e01533"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "rankTypeTitle" }, "2026软科中国大学排名", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "littleTitle" }, "排名对象：", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "normalText" }, " “2026软科中国大学排名”的排名对象是教育部最近一次公布的全国普通高等学校名单（截至2025年6月20日）中办学层次为本科，并且同时符合以下两项条件的高校： ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pointText" }, "• 2024年有本科毕业生；", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pointText" }, "• 专任教师不少于100人。", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "normalText" }, " 教育部公布名单后至今（截至2025年12月31日）已更名、转设、终止办学的高校，在排名中采用变更后的信息。此外，中国消防救援学院、中国科学院大学、中国社会科学院大学因情况特殊暂未纳入排名。内蒙古科技大学、内蒙古科技大学包头师范学院、内蒙古科技大学包头医学院在教育部公布名单中是一所高校，但它们各自独立招生与办学，因此作为三所学校分别计算排名。 ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "normalText" }, " 2020年5月，教育部印发《关于加快推进独立学院转设工作的实施方案》，提出了“转为民办、转为公办、终止办学”的转设路径。2022年起，“软科中国大学排名”不再对独立学院单独排名，已转设为公办高校的纳入主榜或相应单科性大学排名，已转设为民办高校的纳入民办高校排名。 ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "normalText" }, " 2019年1月，国务院印发《国家职业教育改革实施方案》，明确职业教育与普通教育是两种不同教育类型，提出开展本科层次职业教育试点。为了鼓励职业本科院校保持职业教育属性和特色，2025年起“软科中国大学排名”不再纳入职业大学和职业技术大学，职业本科院校将被纳入“软科中国高职院校排名”。 ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "normalText" }, " “2026软科中国大学排名”的最终排名对象共计1086所，其中公办大学842所、民办高校235所、中外合作办学及内地与港澳台地区合作办学9所。 ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "normalText" }, " 由于中国高等教育体系的特点，为保证高校之间的可比性和比较的公平性，“2026软科中国大学排名”设置了1个主榜（综合性大学排名）、7个单科性大学排名、4个非公办高校排名，以及艺术类高校名单，1086所高校根据学校性质和学校类型被分别纳入到其中一个对应的排名或名单中。 ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "littleTitle" }, "评价体系：", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "normalText" }, " “软科中国大学排名”的评价体系源自自主研发的可视化评价专利技术，依托“大学360度数据监测平台”的大数据支持，设置办学层次、学科水平、办学资源、师资规模与结构、人才培养、科学研究、服务社会、高端人才、重大项目与成果、国际竞争力共十个评价模块，细分35个评价维度，内嵌104项评价指标，涉及398个评价变量，是对中国大学办学水平的立体化监测式评价。 ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "normalText" }, " “软科中国大学排名”遵循“全面评估、分类评价”的原则，针对不同性质和不同类型大学的特点，采用差异化的指标体系进行排名。 ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "rankTypeTitle" }, "QS 2027年世界大学排名", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "littleTitle" }, "排名对象：", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "normalText" }, " 2027版本共评估了来自13个国家和地区的1504所大学，覆盖本科、硕士与博士各层次的教学和科研质量。", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "littleTitle" }, "评价体系：", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "normalText" }, " QS 世界大学排名由 Quacquarelli Symonds 自 2004 年起发布，最显著的特征是对声誉评价的高度重视：学术声誉（30%）与雇主声誉（15%）合计占比近半，直接反映全球学者和用人单位对院校的认可度。此外还包括师生比（10%）、单位教师论文引用数（20%）、国际教师比例（5%）、国际学生比例（5%）以及可持续发展、就业成果等新增维度。确保排名能够反映各校在师资力量、学术产出、国际化水平和毕业生竞争力等方面的最新表现，为学生选校、家长规划和教育研究者提供可靠参考。 ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "rankTypeTitle" }, "2026校友会中国大学排名", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "littleTitle" }, "排名对象：", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "normalText" }, " 校友会2026中国大学排名评价院校涵盖我国海峡两岸暨香港澳门地区的2000多所公办本科大学、民办大学（含独立学院）、中外合作办学大学、职业技术大学和高职（专科）院校等高校。需要指出的是，今年将中国科学院大学、中国社会科学院大学，南方科技大学、上海科技大学、深圳理工大学、大湾区大学、西湖大学、福建福耀科技大学、宁波东方理工大学、国防科技大学、海军军医大学、战略支援部队信息工程大学、空军军医大学、空军工程大学、陆军工程大学、海军工程大学、陆军军医大学等纳入校友会2026中国大学排名（总榜）进行评价和呈现。 ", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "littleTitle" }, "评价体系：", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "normalText" }, " 校友会中国大学排名评价指标体系涵盖人才培养、科学研究、社会服务、文化传承创新、国际交流合作等五大核心职能。以服务国家“双一流”建设为导向，评估指标均与国家“双一流”建设目标要求相一致，推动中国大学内涵式发展，引导中国高校坚持以立德树人成效作为根本标准，扎根中国大地办大学，提升服务国家地方经济社会发展的能力，增强社会影响力与核心竞争力。校友会2026中国大学排名评价指标体系由办学层次、思政教育、教学质量、高层次人才、杰出校友、学科专业、科研基地、科研项目、科研成果、社会服务、社会声誉和国际影响力等十二项一级指标组成，以艾瑞深大学360度全景数据平台为数据支持，基于“大平台、大团队、大项目、大成果、大校友”体系框架展开系统评价，涵盖的评价指标高达900多项，是目前中国评价指标最多的中国大学排名。 ", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "rankTypeTitle" }, "2025-2026年中国科教评价网研究生教育高校竞争力排行榜", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "littleTitle" }, "排名对象：", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "normalText" }, " 2025版研究生教育评价的对象为中国内地的592个研究生培养单位（不含部分军事类院校和港澳台地区高校），从学校、地区、类型、一级学科等多个维度，对培养单位的研究生教育竞争力进行了全面、系统和深入的评价。 ", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "littleTitle" }, "评价体系：", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "normalText" }, " 2025年金平果中国研究生教育分一级学科竞争力排行榜，有以下变化： ", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "normalText" }, " 1、数据合并：评价过程中将一级学科专业学位和学术学位相关学科数据合并，因此今年的学科排名体现了学术学位和专业学位的综合实力，不再单独发布专业学位学科排行榜。 ", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "normalText" }, " 2、范围扩大：排行榜单发布范围从以前的前20%（四星以上）扩大到前50%，公布三星级及以上学科名单。 ", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "normalText" }, " 3、新增学科：新增发布交叉门类下的集成电路科学与工程、国家安全学、设计学(交叉)、智能科学与技术等四个一级学科排行榜。 ", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "rankTypeTitle" }, "2023中国科教评价网中国高校一流学科建设综合竞争力排行榜", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "littleTitle" }, "排名对象：", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "normalText" }, " “金平果”2023大学评价以教育部最新公布的《2023年全国高等学校名单》为依据，结合学校的实际招生情况，最终确定本次大学评价的对象为2751所高校（不含中国港、澳、台地区），其中普通本科院校1223所、高职院校1487所、职业本科大学32所、中外合作办学9所。", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "littleTitle" }, "评价体系：", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "normalText" }, " 采用“政治标准、业务标准、效益标准”三结合的教育评价体系。 ", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "rankTypeTitle" }, "2026软科中国高职院校排名", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "littleTitle" }, "排名对象：", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "normalText" }, " “2026 软科中国高职院校排名”分为本科层次的“职业本科大学排名”和专科层次的“高职专科院校排名”两大类。其中，“职业本科大学排名”的排名对象是同时符合以下五项条件的高校：（1）教育部最近一次公布的全国普通高等学校名单（截至2026年6月17日）中办学层次为本科的高校；（2）校名中包含“职业大学”或“职业技术大学”；（3）2024年有毕业生；（4）在校生人数不少于2000人；（5）专任教师不少于100人。“高职专科院校排名”的排名对象是同时符合以下四项条件的高校：（1）教育部最近一次公布的全国普通高等学校名单（截至2026年6月17日）中办学层次为专科的高校；（2）2024年有专科毕业生；（3）在校生人数不少于2000 人；（4）专任教师不少于100人。 ", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "normalText" }, " “2026 软科中国高职院校排名”的最终排名对象共计1401所，其中职业本科大学123所、高职专科院校1278所。职业本科大学中，公办院校96所、民办院校27所；高职专科院校中，公办院校971所、民办与中外合作办学院校307所。此外，江苏联合职业技术学院因情况特殊暂未纳入排名。 ", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "normalText" }, " “2026 软科中国高职院校排名”实行分层分类评价的方法，对于职业本科大学，设置了中国职业本科大学排名和民办职业本科大学排名2个子榜单；对于高职专科院校，细分为9个类型的公办高职专科院校排名和1个民办高职专科院校排名。1401所高职院校根据学校性质和学校类型被分别纳入到其中一个对应的排名中。 ", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "littleTitle" }, "评价体系：", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "normalText" }, " 软科中国高职院校排名的评价体系依托“高职360度数据监测平台”的大数据支持，设置立德树人、办学定位、师资队伍、培养条件、学生发展、服务社会六个评价模块，细分28个评价维度，内嵌64个评价指标，采用196 个评价变量，是对中国高职院校办学水平的立体化监测式评价。 ", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "rankTypeTitle" }, "2026-2027年中国科教评价网中国高职高专院校竞争力排行榜", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "littleTitle" }, "排名对象：", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "normalText" }, " 金平果2026高职教育评价范围以教育部最新公布的《2025年全国高等学校名单》为依据，结合学校的实际招生情况，确定高职院校评价对象为1641所，其中高职高专1554所、职业本科87所，从学校、地区、类型、专业大类、专业类、专业和专业群等14个不同维度评价得出1669个排行榜。 ", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "littleTitle" }, "评价体系：", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "normalText" }, " 金平果2026高职院校排行榜继续采用得分、排名、等级与位次比相结合的表示方法，便于从宏观和微观分别了解各自定位。院校等级由5★+、5★、5★-、4★、3★、2★、1★组成，分别对应于排名前1%、1-5%、5-10%、10-20%、20-50%、50-90%、90-100%的高职院校。 ", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "rankTypeTitle" }, "2026-2027年中国科教评价网职业本科院校综合竞争力排行榜", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "littleTitle" }, "排名对象：", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "normalText" }, " 金平果2026高职院校评价范围以教育部公布的《2025年全国高等学校名单》为依据，结合学校的实际招生情况。 ", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "littleTitle" }, "评价体系：", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "normalText" }, " 金平果2026高职院校排行榜继续采用得分、排名、等级与位次比相结合的表示方法，便于从宏观和微观分别了解各自定位。院校等级由5★+、5★、5★-、4★、3★、2★、1★组成，分别对应于排名前1%、1-5%、5-10%、10-20%、20-50%、50-90%、90-100%的高职院校。 ", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "rankTypeTitle" }, "2026-2027年中国科教评价网中国大学本科院校竞争力总排行榜", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "littleTitle" }, "排名对象：", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "normalText" }, " “金平果”2026大学评价以教育部公布的《2025年全国高等学校名单》为依据，结合学校的实际招生情况。 2026年中国大学本科院校竞争力总排行榜暂未公布参与排名院校数量，院校数量参考2025-2026年中国科教评价网中国大学本科院校竞争力总排行榜。 ", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "littleTitle" }, "评价体系：", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "normalText" }, " 金平果2026年大学评价与时俱进，采用“政治标准、业务标准、效益标准”三结合的教育评价体系。中国本科院校综合竞争力评价指标体系设3个一级指标，9个二级指标，34个三级指标。一级指标包括政治标准、业务标准和效益标准3个方面，二级指标包括立德树人、教学水平、科研水平、学术效益等9个方面，三级指标包括杰出人才、学生培养、新生质量、论文质量等34个方面。 ", -1))
const _hoisted_59 = { id: "CollegeSituationBackground" }
const _hoisted_60 = { id: "CollegeSituationBody" }
const _hoisted_61 = { id: "CollegeSituationLeft" }
const _hoisted_62 = {
  key: 1,
  class: "greyBackgroundContainer"
}
const _hoisted_63 = {
  key: 0,
  id: "realisticVrContainer"
}
const _hoisted_64 = ["href"]
const _hoisted_65 = ["src"]
const _hoisted_66 = { id: "greyBackgroundContainer" }
const _hoisted_67 = { id: "greyBackgroundText" }
const _hoisted_68 = { id: "learnMoreContainer" }
const _hoisted_69 = ["href"]
const _hoisted_70 = {
  key: 2,
  id: "iconContainer"
}
const _hoisted_71 = {
  key: 0,
  class: "iconItemContainer"
}
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_73 = { class: "iconText" }
const _hoisted_74 = {
  key: 1,
  class: "iconItemContainer"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_76 = { class: "iconText iconTextLong" }
const _hoisted_77 = {
  key: 2,
  class: "iconItemContainer"
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1))
const _hoisted_79 = { class: "iconText iconTextLong" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_81 = {
  key: 3,
  class: "iconItemContainer"
}
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 })
], -1))
const _hoisted_83 = { class: "iconText iconTextLong" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_85 = {
  key: 4,
  class: "iconItemContainer",
  id: "ratioContainer"
}
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon",
  id: "ratioEchartContainer"
}, null, -1))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "ratioEchartImg" }, null, -1))
const _hoisted_88 = { class: "iconText" }
const _hoisted_89 = {
  key: 4,
  class: "greyBackgroundContainer"
}
const _hoisted_90 = { class: "greyBackgroundText" }
const _hoisted_91 = {
  key: 6,
  class: "greyBackgroundContainer"
}
const _hoisted_92 = { class: "greyBackgroundText" }
const _hoisted_93 = {
  key: 8,
  class: "greyBackgroundContainer"
}
const _hoisted_94 = { class: "greyBackgroundForm" }
const _hoisted_95 = { class: "formText" }
const _hoisted_96 = { class: "formText" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "博士二级学科", -1))
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "autonomousSettings" }, "(含自主设置)", -1))
const _hoisted_99 = { class: "formText" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "博士交叉学科", -1))
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "autonomousSettings" }, "(含自主设置)", -1))
const _hoisted_102 = { class: "formText" }
const _hoisted_103 = { class: "formText" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "硕士二级学科", -1))
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "autonomousSettings" }, "(含自主设置)", -1))
const _hoisted_106 = { class: "formText" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "硕士交叉学科", -1))
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "autonomousSettings" }, "(含自主设置)", -1))
const _hoisted_109 = { class: "formText" }
const _hoisted_110 = { class: "formText" }
const _hoisted_111 = {
  key: 10,
  id: "masterDetailsContainer",
  class: "greyBackgroundContainer"
}
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "本科", -1))
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "毕业生", -1))
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "人数", -1))
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "推免", -1))
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "人数", -1))
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "读研人数", -1))
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "(国内+", -1))
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "国外)", -1))
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "出国", -1))
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "(境)", -1))
const _hoisted_122 = {
  key: 12,
  class: "greyBackgroundContainer"
}
const _hoisted_123 = ["innerHTML"]
const _hoisted_124 = {
  key: 14,
  class: "greyBackgroundContainer"
}
const _hoisted_125 = { class: "greyBackgroundText" }
const _hoisted_126 = {
  key: 16,
  id: "nationalCharacteristicMajors",
  class: "greyBackgroundContainer"
}
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "nationalCharacteristicMajorsTitle" }, [
  /*#__PURE__*/_createElementVNode("div", null, "国家"),
  /*#__PURE__*/_createElementVNode("div", null, "特色"),
  /*#__PURE__*/_createElementVNode("div", null, "专业")
], -1))
const _hoisted_128 = {
  id: "nationalCharacteristicMajorsText",
  class: "greyBackgroundText"
}
const _hoisted_129 = {
  key: 17,
  id: "subjectSetup",
  class: "greyBackgroundContainer"
}
const _hoisted_130 = { class: "centerTd" }
const _hoisted_131 = {
  key: 19,
  id: "majorAssess",
  class: "greyBackgroundContainer"
}
const _hoisted_132 = { class: "majorAssessResultContainer" }
const _hoisted_133 = { class: "majorAssessResult" }
const _hoisted_134 = {
  key: 21,
  class: "greyBackgroundContainer"
}
const _hoisted_135 = { class: "greyBackgroundForm" }
const _hoisted_136 = { class: "formText" }
const _hoisted_137 = { class: "formText" }
const _hoisted_138 = { class: "formText" }
const _hoisted_139 = { class: "formText" }
const _hoisted_140 = { class: "formText" }
const _hoisted_141 = { class: "formText" }
const _hoisted_142 = { id: "CollegeSituationRight" }
const _hoisted_143 = {
  key: 1,
  id: "collegeRankContainer"
}
const _hoisted_144 = {
  key: 2,
  id: "collegeRankLearnMoreContainer"
}
const _hoisted_145 = {
  key: 4,
  id: "collegeInformationContainer"
}
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "•", -1))
const _hoisted_147 = ["href"]
const _hoisted_148 = { id: "authorityInfoContainer" }
const _hoisted_149 = { class: "authorityInfoTitle" }
const _hoisted_150 = { class: "authorityInfoTitle" }
const _hoisted_151 = { class: "authorityInfoTitle" }
const _hoisted_152 = { class: "authorityInfoTitle" }
const _hoisted_153 = { class: "authorityInfoBody" }
const _hoisted_154 = { class: "authorityInfoTitle" }
const _hoisted_155 = { class: "authorityInfoBody" }
const _hoisted_156 = { class: "authorityInfoTitle" }
const _hoisted_157 = { class: "authorityInfoBody" }
const _hoisted_158 = { id: "CollegeSituationFooter" }
const _hoisted_159 = { id: "instructions" }
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "instructionsTitle" }, "系统使用说明", -1))
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "formText" }, "本查询系统数据来源于教育部官网、阳光高考、各省教育考试院、各院校官网及招生就业网、软科官网、中国科教评价网、麦可思研究院等，数据仅供参考，具体数据请以学校官网或考试院最新公布为准。", -1))
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "formText" }, "本站数据未经授权严禁转载，违者将依法追究责任。", -1))
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "formText" }, "如对本系统或相关服务有任何疑问，可拨打电话400-018-0810反馈于我们。", -1))
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "qrCodeContainer" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "qrCodeItem" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_4 })
  ])
], -1))

import * as echarts from "echarts"
  import {ref, reactive, onBeforeUpdate, onMounted, computed, nextTick} from 'vue'
  import RightTitle from '@/components/collegeSituation/RightTitle.vue'
  import LeftTitle from '@/components/collegeSituation/LeftTitle.vue'
  import {Search} from '@element-plus/icons-vue'
  import {useRoute, useRouter} from 'vue-router'
  // 必须先声明调用
  import {
    collegeGetRecruitRule,
    getLeft123,
    getLeft4,
    getLeft5, getLeft6, getLeft7,
    getRight1,
    getRight3,
    getRight4
  } from "@/network/axios";


  // onBeforeUpdate(()=>{
  //   const overHg = document.getElementsByClassName('el-table__body')[0].clientHeight + 'px' ;
  //   const wrapper = document.getElementsByClassName('el-table__body-wrapper')[0] as HTMLElement;
  //   wrapper.style.maxHeight = overHg;
  // });


  
export default /*#__PURE__*/_defineComponent({
  __name: 'MobileCollegeSituation',
  setup(__props) {

  const route = useRoute();
  const router = useRouter();

  let displayTable = ref(false);

  let collegeInfo: any = reactive({
    //百度链接
    collegeBaidu: '',
    //院校简介
    collegeInfo: '',
    //五个icon 时间 地址 硕士 博士 男女比例
    collegeTime: '',
    collegeCity: '',
    master: '',
    doctor: '',
    ratio: '',
    //师资力量
    teachers: '',
    //优势
    advantage: '',
    //院校其他信息
    //重点实验(实训)室
    keyLab: '',
    //奖学金设置
    scholarship: '',
    //食宿条件
    accommodation: '',
    //转专业实施办法
    transferMajor: '',
    //知名校友
    oldBoy: '',
    //校招企业
    enterprise: '',

    //硕博点介绍
    programs: {
      mdDetail: '',
      masterFirst: '',
      masterSecond: '',
      professionalMaster: '',
      masterInterdisciplinary: '',
      doctorFirst: '',
      doctorSecond: '',
      doctorInterdisciplinary: '',
    },
    //保研率详情
    masterDetails: [],
    //双一流建设学科
    doubleFirstClass: '',
    //专业设置  国家特色专业  专业表格
    // specialtyMajor: '',
    collegeMajor: [],
    //左半部分 学科评估
    subjectReview: [],
    //右半部分 VR 照片链接
    vrAddress: '',
    picLink: '',
    //右半部分 高校排名
    collegeRank: [],

    //右半部分 院校资讯
    // collegeInformation: {
    //   news: [],
    //   workReport: [],
    // },
    collegeInformation: [],
    //右半部分 联系方式
    contact: {
      website: '',
      recruitWebsite: '',
      collegePhone: [],
      collegeMain: '',
      collegeAddress: '',
      masterWebsite:'',
    },
  });

  //左半部分 专业录取规则
  let admissionsRules =ref('');
  let getAdmissionsRules =()=>{
    collegeGetRecruitRule('/college/getRecruitRule',{
      params:{
        collegeCode:route.params.id
      }
    }).then((res)=>{
      if (res.data.code == 200){
        admissionsRules.value = res.data.data
      }
    })
  }
  getAdmissionsRules()


  //左半部分 硕博点介绍
  getLeft6('/college/getMdDetails', {
    params: {
      collegeCode: route.params.id
    }
  }).then((res) => {
    // console.log(res.data);
    if (res.data.data != '') {
      collegeInfo.programs.mdDetail = res.data.data.mdDetail;
      collegeInfo.programs.masterFirst = res.data.data.masterFirst;
      collegeInfo.programs.masterSecond = res.data.data.masterSecond;
      collegeInfo.programs.professionalMaster = res.data.data.professionalMaster;
      collegeInfo.programs.masterInterdisciplinary = res.data.data.masterInterdisciplinary;
      collegeInfo.programs.doctorFirst = res.data.data.doctorFirst;
      collegeInfo.programs.doctorSecond = res.data.data.doctorSecond;
      collegeInfo.programs.doctorInterdisciplinary = res.data.data.doctorInterdisciplinary;
    }
  });

  getLeft7('/college/getCollegeMasterDetails', {
    params: {
      collegeCode: route.params.id
    }
  }).then((res) => {
    collegeInfo.masterDetails = [];
    for (let i = 0; i < res.data.data.length; i++) {
      if (res.data.data[i].abroad == '') {
        res.data.data[i].abroad = '--'
      }
      if (res.data.data[i].graduationNum == '') {
        res.data.data[i].graduationNum = '--'
      }
      if (res.data.data[i].home == '') {
        res.data.data[i].home = '--'
      }
      if (res.data.data[i].masterNum == '') {
        res.data.data[i].masterNum = '--'
      }
      if (res.data.data[i].masterRate == '') {
        res.data.data[i].masterRate = '--'
      } else {
        res.data.data[i].masterRate = (parseFloat(res.data.data[i].masterRate)).toFixed(2) + '%'
      }
      if (res.data.data[i].num == '') {
        res.data.data[i].num = '--'
      }
      if (res.data.data[i].year == '') {
        res.data.data[i].year = '--'
      }
    }
    collegeInfo.masterDetails = res.data.data;
    // console.log(res.data)
  })

  // 左半部分 专业设置
  getLeft4('/college/getCollegeMajor', {
    params: {
      // collegeCode: 'A1'
      collegeCode: route.params.id
    }
  }).then((res) => {
    // console.log(res.data);
    // collegeInfo.specialtyMajor = res.data.data.specialty;
    // if (res.data.data.collegeMajor != '') {
    //   collegeInfo.collegeMajor = [];
    //   collegeInfo.collegeMajor = JSON.parse(res.data.data.collegeMajor);
    // } else {
    //   collegeInfo.collegeMajor = res.data.data.collegeMajor;
    // }
    if (res.data.code == 200) {
      collegeInfo.collegeMajor = [];
      collegeInfo.collegeMajor = res.data.data
    } else {
      collegeInfo.collegeMajor = [];
    }

  });

  //左半部分 学科评估
  getLeft5('/college/getMajorsEstimate', {
    params: {
      collegeCode: route.params.id
    }
  }).then((res) => {
    // console.log(res.data)
    collegeInfo.subjectReview = [];
    collegeInfo.subjectReview = res.data.data;

  });

  // 右半部分 高校排行
  getRight1('/college/getRankInfo', {
    params: {
      collegeCode: route.params.id
    }
  }).then((res) => {
    // console.log(res.data)
    collegeInfo.collegeRank = [];
    collegeInfo.collegeRank = res.data.data;
    // console.log(collegeInfo.collegeRank)
  });


  // 右半部分 院校资讯
  getRight3('/college/getNewsAndWorkReport', {
    params: {
      collegeCode: route.params.id
    }
  }).then((res) => {
    // console.log(res.data)
    // collegeInfo.collegeInformation.news = [];
    // collegeInfo.collegeInformation.news = res.data.data.news;
    // collegeInfo.collegeInformation.workReport = [];
    // collegeInfo.collegeInformation.workReport = res.data.data.workReport;
    collegeInfo.collegeInformation = [];
    collegeInfo.collegeInformation = res.data.data
  });

  // 右半部分 联系方式
  getRight4('/college/getContactDetails', {
    params: {
      collegeCode: route.params.id
    }
  }).then((res) => {
    // console.log(res.data)
    collegeInfo.contact.website = res.data.data.website;
    collegeInfo.contact.recruitWebsite = res.data.data.recruitWebsite;
    collegeInfo.contact.collegePhone = [];
    collegeInfo.contact.collegePhone = res.data.data.collegePhone;
    collegeInfo.contact.collegeMain = res.data.data.collegeMain;
    collegeInfo.contact.collegeAddress = res.data.data.collegeAddress;
    collegeInfo.contact.masterWebsite =res.data.data.masterWebsite;
    // console.log(collegeInfo.contact)
  });

  let isPrograms = computed(() => {
    if (collegeInfo.programs.doctorSecond == '' && collegeInfo.programs.doctorFirst == '' && collegeInfo.programs.masterInterdisciplinary == '' && collegeInfo.programs.professionalMaster == '' && collegeInfo.programs.masterSecond == '' && collegeInfo.programs.masterFirst == '' && collegeInfo.programs.doctorInterdisciplinary == '' && collegeInfo.programs.mdDetail == '') {
      return false
    } else {
      return true
    }
  });

  let isCollegeOtherInfo = computed(() => {
    if (collegeInfo.keyLab == '' && collegeInfo.scholarship == '' && collegeInfo.accommodation == '' && collegeInfo.transferMajor == '' && collegeInfo.oldBoy == '' && collegeInfo.enterprise == '') {
      return false
    } else {
      return true
    }
  });

  onMounted(() => {
    //左半部分 院校简介、双一流建设学科
    getLeft123('/college/getCollegeInfo', {
      params: {
        // collegeCode: 'A1'
        collegeCode: route.params.id
      }
    }).then((res) => {
      // console.log(res.data);
      collegeInfo.collegeBaidu = res.data.data.collegeBaidu;
      collegeInfo.collegeInfo = res.data.data.collegeInfo;
      collegeInfo.collegeTime = res.data.data.collegeTime;
      collegeInfo.doctor = res.data.data.doctor;
      collegeInfo.doubleFirstClass = res.data.data.doubleFirstClass.split('、').join('|');
      collegeInfo.master = res.data.data.master;
      collegeInfo.collegeCity = res.data.data.collegeCity;
      if (res.data.data.ratio != '') {
        collegeInfo.ratio = res.data.data.ratio.split(':');
      } else {
        collegeInfo.ratio = res.data.data.ratio;
      }
      collegeInfo.vrAddress = res.data.data.vrAddress;
      collegeInfo.picLink = res.data.data.picLink;
      collegeInfo.teachers = res.data.data.teachers;
      collegeInfo.advantage = res.data.data.advantage;
      //院校其他信息
      collegeInfo.keyLab = res.data.data.keyLab;
      collegeInfo.scholarship = res.data.data.scholarship;
      collegeInfo.accommodation = res.data.data.accommodation;
      collegeInfo.transferMajor = res.data.data.transferMajor;
      collegeInfo.oldBoy = res.data.data.oldBoy;
      collegeInfo.enterprise = res.data.data.enterprise;

      //男女比例的 echart图
      nextTick(() => {
        if (res.data.data.ratio != '') {
          (() => {
            let chartDom = document.getElementById('ratioEchartContainer') as HTMLElement;
            if (chartDom.hasAttribute("_echarts_instance_")) {
              chartDom.removeAttribute("_echarts_instance_");
            }
            let myChart = echarts.init(chartDom);
            let option;
            option = {
              // tooltip: {
              //   trigger: 'item',
              //   formatter: "{b} : {c} ({d}%)"
              // },
              color: ['#4d9cd0', '#cd3532'],
              animation: false,
              series: [
                {
                  name: 'Access From',
                  type: 'pie',
                  radius: ['67%', '99%'],
                  emphasis: {
                    disabled: true,
                  },
                  avoidLabelOverlap: false,

                  label: {
                    show: false,
                    position: 'center'
                  },

                  labelLine: {
                    show: false
                  },
                  data: [
                    {value: collegeInfo.ratio[0], name: '男'},
                    {value: collegeInfo.ratio[1], name: '女'},
                  ]
                }
              ]
            };
            option && myChart.setOption(option);
          })();
        }
      })
    });
  });

  let clickOfficialWebsite = (website: any) => {
    window.open(website)
  }

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_Coordinate = _resolveComponent("Coordinate")!
  const _component_Place = _resolveComponent("Place")!
  const _component_Phone = _resolveComponent("Phone")!
  const _component_Message = _resolveComponent("Message")!
  const _component_LocationInformation = _resolveComponent("LocationInformation")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      modelValue: _unref(displayTable),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(displayTable) ? (displayTable).value = $event : displayTable = $event)),
      width: "800",
      "align-center": true,
      "lock-scroll": false,
      id: "elDialogMobile"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: _unref(collegeInfo).collegeRank,
          height: "160",
          id: "rankDetailTable"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              "show-overflow-tooltip": true,
              prop: "collegeRanksName",
              label: "排行榜",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              "show-overflow-tooltip": true,
              prop: "years",
              label: "排名时间",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              "show-overflow-tooltip": true,
              prop: "ranks",
              label: "院校排名",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              "show-overflow-tooltip": true,
              prop: "numbers",
              label: "总院校数",
              align: "center"
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(_component_el_scrollbar, { height: "315" }, {
          default: _withCtx(() => [
            _hoisted_1,
            _hoisted_2,
            _hoisted_3,
            _hoisted_4,
            _hoisted_5,
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            _hoisted_9,
            _hoisted_10,
            _hoisted_11,
            _hoisted_12,
            _hoisted_13,
            _hoisted_14,
            _hoisted_15,
            _hoisted_16,
            _hoisted_17,
            _hoisted_18,
            _hoisted_19,
            _hoisted_20,
            _hoisted_21,
            _hoisted_22,
            _hoisted_23,
            _hoisted_24,
            _hoisted_25,
            _hoisted_26,
            _hoisted_27,
            _hoisted_28,
            _hoisted_29,
            _hoisted_30,
            _hoisted_31,
            _hoisted_32,
            _hoisted_33,
            _hoisted_34,
            _hoisted_35,
            _hoisted_36,
            _hoisted_37,
            _hoisted_38,
            _hoisted_39,
            _hoisted_40,
            _hoisted_41,
            _hoisted_42,
            _hoisted_43,
            _hoisted_44,
            _hoisted_45,
            _hoisted_46,
            _hoisted_47,
            _hoisted_48,
            _hoisted_49,
            _hoisted_50,
            _hoisted_51,
            _hoisted_52,
            _hoisted_53,
            _hoisted_54,
            _hoisted_55,
            _hoisted_56,
            _hoisted_57,
            _hoisted_58
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_59, [
      _createElementVNode("div", _hoisted_60, [
        _createElementVNode("div", _hoisted_61, [
          (_unref(collegeInfo).picLink!='')
            ? (_openBlock(), _createBlock(LeftTitle, {
                key: 0,
                title: "实景VR"
              }))
            : _createCommentVNode("", true),
          (_unref(collegeInfo).picLink!='')
            ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                (_unref(collegeInfo).picLink!='')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                      _createElementVNode("a", {
                        href: _unref(collegeInfo).vrAddress,
                        target: "_blank"
                      }, [
                        _createElementVNode("img", {
                          src: _unref(collegeInfo).picLink
                        }, null, 8, _hoisted_65)
                      ], 8, _hoisted_64)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createVNode(LeftTitle, { title: "院校简介" }),
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("div", _hoisted_67, _toDisplayString(_unref(collegeInfo).collegeInfo), 1),
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("a", {
                href: _unref(collegeInfo).collegeBaidu,
                target: "_blank"
              }, "了解更多>>", 8, _hoisted_69)
            ])
          ]),
          (!(_unref(collegeInfo).collegeTime == ''&&_unref(collegeInfo).collegeCity == ''&&_unref(collegeInfo).master == ''&&_unref(collegeInfo).doctor == ''&&_unref(collegeInfo).ratio == ''))
            ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                (_unref(collegeInfo).collegeTime != '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                      _hoisted_72,
                      _createElementVNode("div", _hoisted_73, _toDisplayString(_unref(collegeInfo).collegeTime), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(collegeInfo).collegeCity != '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                      _hoisted_75,
                      _createElementVNode("div", _hoisted_76, _toDisplayString(_unref(collegeInfo).collegeCity), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(collegeInfo).master != '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                      _hoisted_78,
                      _createElementVNode("div", _hoisted_79, [
                        _createTextVNode(_toDisplayString(_unref(collegeInfo).master) + " ", 1),
                        _createVNode(_component_el_tooltip, { effect: "dark" }, {
                          content: _withCtx(() => [
                            _createTextVNode(" 指院校各类型硕士点数量，自左到右依次为："),
                            _hoisted_80,
                            _createTextVNode("一级学科/二级学科（含自主设置）/交叉学科（含自主设置）/专硕 ")
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, {
                              size: "15px",
                              class: "masterDoctorIcon"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_QuestionFilled)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(collegeInfo).doctor != '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                      _hoisted_82,
                      _createElementVNode("div", _hoisted_83, [
                        _createTextVNode(_toDisplayString(_unref(collegeInfo).doctor) + " ", 1),
                        _createVNode(_component_el_tooltip, { effect: "dark" }, {
                          content: _withCtx(() => [
                            _createTextVNode(" 指院校各类型博士点数量，自左到右依次为："),
                            _hoisted_84,
                            _createTextVNode("一级学科/二级学科（含自主设置）/交叉学科（含自主设置） ")
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, {
                              size: "15px",
                              class: "masterDoctorIcon"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_QuestionFilled)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(collegeInfo).ratio != '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                      _hoisted_86,
                      _hoisted_87,
                      _createElementVNode("div", _hoisted_88, _toDisplayString(_unref(collegeInfo).ratio[0]) + ":" + _toDisplayString(_unref(collegeInfo).ratio[1]), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_unref(admissionsRules) != '')
            ? (_openBlock(), _createBlock(LeftTitle, {
                key: 3,
                title: "专业录取规则"
              }))
            : _createCommentVNode("", true),
          (_unref(admissionsRules) != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                _createElementVNode("div", _hoisted_90, _toDisplayString(_unref(admissionsRules)), 1)
              ]))
            : _createCommentVNode("", true),
          (_unref(collegeInfo).teachers != '')
            ? (_openBlock(), _createBlock(LeftTitle, {
                key: 5,
                title: "师资力量"
              }))
            : _createCommentVNode("", true),
          (_unref(collegeInfo).teachers != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                _createElementVNode("div", _hoisted_92, _toDisplayString(_unref(collegeInfo).teachers), 1)
              ]))
            : _createCommentVNode("", true),
          (_unref(isPrograms))
            ? (_openBlock(), _createBlock(LeftTitle, {
                key: 7,
                title: "硕博点介绍"
              }))
            : _createCommentVNode("", true),
          (_unref(isPrograms))
            ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                _createElementVNode("div", _hoisted_94, [
                  _createVNode(_component_el_form, { "label-width": "100px" }, {
                    default: _withCtx(() => [
                      (_unref(collegeInfo).programs.mdDetail!='')
                        ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
                            label: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_el_tag, {
                                  type: "danger",
                                  class: "MasterAndDoctorTag"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("硕博点概况")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_95, _toDisplayString(_unref(collegeInfo).programs.mdDetail), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_unref(collegeInfo).programs.doctorFirst!='')
                        ? (_openBlock(), _createBlock(_component_el_form_item, { key: 1 }, {
                            label: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_el_tag, {
                                  type: "danger",
                                  class: "MasterAndDoctorTag"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("博士一级学科")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_96, _toDisplayString(_unref(collegeInfo).programs.doctorFirst), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_unref(collegeInfo).programs.doctorSecond!='')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 2,
                            class: "haveTwoLine"
                          }, {
                            label: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_el_tag, {
                                  type: "danger",
                                  class: "MasterAndDoctorTag",
                                  size: "large"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_97,
                                    _hoisted_98
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_99, _toDisplayString(_unref(collegeInfo).programs.doctorSecond), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_unref(collegeInfo).programs.doctorInterdisciplinary!='')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 3,
                            class: "haveTwoLine"
                          }, {
                            label: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_el_tag, {
                                  type: "danger",
                                  class: "MasterAndDoctorTag",
                                  size: "large"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_100,
                                    _hoisted_101
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_102, _toDisplayString(_unref(collegeInfo).programs.doctorInterdisciplinary), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_unref(collegeInfo).programs.masterFirst!='')
                        ? (_openBlock(), _createBlock(_component_el_form_item, { key: 4 }, {
                            label: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_el_tag, {
                                  type: "danger",
                                  class: "MasterAndDoctorTag"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("硕士一级学科")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_103, _toDisplayString(_unref(collegeInfo).programs.masterFirst), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_unref(collegeInfo).programs.masterSecond!='')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 5,
                            class: "haveTwoLine"
                          }, {
                            label: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_el_tag, {
                                  type: "danger",
                                  class: "MasterAndDoctorTag",
                                  size: "large"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_104,
                                    _hoisted_105
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_106, _toDisplayString(_unref(collegeInfo).programs.masterSecond), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_unref(collegeInfo).programs.masterInterdisciplinary!='')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 6,
                            class: "haveTwoLine"
                          }, {
                            label: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_el_tag, {
                                  type: "danger",
                                  class: "MasterAndDoctorTag",
                                  size: "large"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_107,
                                    _hoisted_108
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_109, _toDisplayString(_unref(collegeInfo).programs.masterInterdisciplinary), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_unref(collegeInfo).programs.professionalMaster!='')
                        ? (_openBlock(), _createBlock(_component_el_form_item, { key: 7 }, {
                            label: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_el_tag, {
                                  type: "danger",
                                  class: "MasterAndDoctorTag"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("专硕")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_110, _toDisplayString(_unref(collegeInfo).programs.professionalMaster), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(collegeInfo).masterDetails != '')
            ? (_openBlock(), _createBlock(LeftTitle, {
                key: 9,
                title: "保研率详情"
              }))
            : _createCommentVNode("", true),
          (_unref(collegeInfo).masterDetails != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                _createVNode(_component_el_table, {
                  data: _unref(collegeInfo).masterDetails,
                  style: {"width":"100%"},
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      prop: "year",
                      label: "年份",
                      align: "center",
                      "min-width": "12%"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "graduationNum",
                      align: "center",
                      "min-width": "15%"
                    }, {
                      header: _withCtx(() => [
                        _hoisted_112,
                        _hoisted_113,
                        _hoisted_114
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "num",
                      align: "center",
                      "min-width": "12.5%"
                    }, {
                      header: _withCtx(() => [
                        _hoisted_115,
                        _hoisted_116
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "masterNum",
                      align: "center",
                      "min-width": "19%"
                    }, {
                      header: _withCtx(() => [
                        _hoisted_117,
                        _hoisted_118,
                        _hoisted_119
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "home",
                      label: "国内",
                      align: "center",
                      "min-width": "12.5%"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "abroad",
                      align: "center",
                      "min-width": "12.5%"
                    }, {
                      header: _withCtx(() => [
                        _hoisted_120,
                        _hoisted_121
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "masterRate",
                      label: "保研率",
                      align: "center",
                      "min-width": "16.5%"
                    })
                  ]),
                  _: 1
                }, 8, ["data"])
              ]))
            : _createCommentVNode("", true),
          (_unref(collegeInfo).advantage != '')
            ? (_openBlock(), _createBlock(LeftTitle, {
                key: 11,
                title: "优势学科"
              }))
            : _createCommentVNode("", true),
          (_unref(collegeInfo).advantage != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                _createElementVNode("div", {
                  class: "greyBackgroundText",
                  innerHTML: _unref(collegeInfo).advantage.replace(/；|;/g, ';<br>    ')
                }, null, 8, _hoisted_123)
              ]))
            : _createCommentVNode("", true),
          (_unref(collegeInfo).doubleFirstClass != '')
            ? (_openBlock(), _createBlock(LeftTitle, {
                key: 13,
                title: "双一流建设学科"
              }))
            : _createCommentVNode("", true),
          (_unref(collegeInfo).doubleFirstClass != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                _createElementVNode("div", _hoisted_125, _toDisplayString(_unref(collegeInfo).doubleFirstClass), 1)
              ]))
            : _createCommentVNode("", true),
          (!( _unref(collegeInfo).collegeMajor.length ==0))
            ? (_openBlock(), _createBlock(LeftTitle, {
                key: 15,
                title: "专业设置"
              }))
            : _createCommentVNode("", true),
          (!(_unref(collegeInfo).collegeMajor.length ==0 ||_unref(collegeInfo).collegeMajor[0].specialty==''))
            ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                _hoisted_127,
                _createElementVNode("div", _hoisted_128, _toDisplayString(_unref(collegeInfo).collegeMajor[0].specialty), 1)
              ]))
            : _createCommentVNode("", true),
          (!(_unref(collegeInfo).collegeMajor.length ==0 ||_unref(collegeInfo).collegeMajor[0].collegeCategory==''))
            ? (_openBlock(), _createElementBlock("div", _hoisted_129, [
                _createVNode(_component_el_table, {
                  data: _unref(collegeInfo).collegeMajor,
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      prop: "collegeCategory",
                      label: "类别",
                      align: "center",
                      "min-width": "26%"
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_130, _toDisplayString(scope.row.collegeCategory), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "collegeMajor",
                      label: "专业",
                      "header-align": "center",
                      align: "left",
                      "min-width": "74%"
                    })
                  ]),
                  _: 1
                }, 8, ["data"])
              ]))
            : _createCommentVNode("", true),
          (_unref(collegeInfo).subjectReview!='')
            ? (_openBlock(), _createBlock(LeftTitle, {
                key: 18,
                title: "第四轮学科评估"
              }))
            : _createCommentVNode("", true),
          (_unref(collegeInfo).subjectReview!='')
            ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                _createVNode(_component_el_table, {
                  data: _unref(collegeInfo).subjectReview,
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      label: "评定结果",
                      align: "center",
                      "min-width": "20%"
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_132, [
                          _createElementVNode("div", _hoisted_133, _toDisplayString(scope.row.majorsLevel), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "majors",
                      label: "学科",
                      align: "left",
                      "header-align": "center",
                      "min-width": "80%"
                    })
                  ]),
                  _: 1
                }, 8, ["data"])
              ]))
            : _createCommentVNode("", true),
          (_unref(isCollegeOtherInfo))
            ? (_openBlock(), _createBlock(LeftTitle, {
                key: 20,
                title: "院校其他信息"
              }))
            : _createCommentVNode("", true),
          (_unref(isCollegeOtherInfo))
            ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                _createElementVNode("div", _hoisted_135, [
                  _createVNode(_component_el_form, { "label-width": "115px" }, {
                    default: _withCtx(() => [
                      (_unref(collegeInfo).keyLab !='')
                        ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
                            label: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_el_tag, {
                                  type: "danger",
                                  class: "collegeOtherInfo"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("重点实验(实训)室")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_136, _toDisplayString(_unref(collegeInfo).keyLab), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_unref(collegeInfo).scholarship !='')
                        ? (_openBlock(), _createBlock(_component_el_form_item, { key: 1 }, {
                            label: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_el_tag, {
                                  type: "danger",
                                  class: "collegeOtherInfo"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("奖学金设置")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_137, _toDisplayString(_unref(collegeInfo).scholarship), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_unref(collegeInfo).accommodation!='')
                        ? (_openBlock(), _createBlock(_component_el_form_item, { key: 2 }, {
                            label: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_el_tag, {
                                  type: "danger",
                                  class: "collegeOtherInfo"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("食宿条件")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_138, _toDisplayString(_unref(collegeInfo).accommodation), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_unref(collegeInfo).transferMajor!='')
                        ? (_openBlock(), _createBlock(_component_el_form_item, { key: 3 }, {
                            label: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_el_tag, {
                                  type: "danger",
                                  class: "collegeOtherInfo"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("转专业实施办法")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_139, _toDisplayString(_unref(collegeInfo).transferMajor), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_unref(collegeInfo).oldBoy!='')
                        ? (_openBlock(), _createBlock(_component_el_form_item, { key: 4 }, {
                            label: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_el_tag, {
                                  type: "danger",
                                  class: "collegeOtherInfo"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("知名校友")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_140, _toDisplayString(_unref(collegeInfo).oldBoy), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_unref(collegeInfo).enterprise!='')
                        ? (_openBlock(), _createBlock(_component_el_form_item, { key: 5 }, {
                            label: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_el_tag, {
                                  type: "danger",
                                  class: "collegeOtherInfo"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("校招企业")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_141, _toDisplayString(_unref(collegeInfo).enterprise), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_142, [
          (_unref(collegeInfo).collegeRank!='')
            ? (_openBlock(), _createBlock(RightTitle, {
                key: 0,
                title: "高校排行"
              }))
            : _createCommentVNode("", true),
          (_unref(collegeInfo).collegeRank!='')
            ? (_openBlock(), _createElementBlock("div", _hoisted_143, [
                _createVNode(_component_el_table, {
                  data: _unref(collegeInfo).collegeRank,
                  "tooltip-effect": "dark",
                  "tooltip-options": {popperClass:'tableTooltip'}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      "show-overflow-tooltip": true,
                      prop: "collegeRanksName",
                      label: "排行榜",
                      align: "center",
                      "min-width": "60%"
                    }),
                    _createVNode(_component_el_table_column, {
                      "show-overflow-tooltip": true,
                      prop: "ranks",
                      label: "院校排名",
                      align: "center",
                      "min-width": "40%"
                    })
                  ]),
                  _: 1
                }, 8, ["data"])
              ]))
            : _createCommentVNode("", true),
          (_unref(collegeInfo).collegeRank!='')
            ? (_openBlock(), _createElementBlock("div", _hoisted_144, [
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_isRef(displayTable) //@ts-ignore
 ? displayTable.value = true : displayTable=true))
                }, "排行榜介绍>>")
              ]))
            : _createCommentVNode("", true),
          (!(_unref(collegeInfo).collegeInformation.length ==0))
            ? (_openBlock(), _createBlock(RightTitle, {
                key: 3,
                title: "院校资讯"
              }))
            : _createCommentVNode("", true),
          (!(_unref(collegeInfo).collegeInformation.length ==0))
            ? (_openBlock(), _createElementBlock("div", _hoisted_145, [
                _createVNode(_component_el_form, {
                  "label-position": "right",
                  "label-width": "30px"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(collegeInfo).collegeInformation, (item, i) => {
                      return (_openBlock(), _createBlock(_component_el_form_item, null, {
                        label: _withCtx(() => [
                          _hoisted_146
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            class: "formText",
                            href: item.newsWebsite,
                            target: "_blank"
                          }, _toDisplayString(item.collegeName) + _toDisplayString(item.years) + "年" + _toDisplayString(item.newsName), 9, _hoisted_147)
                        ]),
                        _: 2
                      }, 1024))
                    }), 256))
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_148, [
            _createVNode(_component_el_form, { "label-width": "110px" }, {
              default: _withCtx(() => [
                (_unref(collegeInfo).contact.website !='')
                  ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
                      label: _withCtx(() => [
                        _createElementVNode("div", _hoisted_149, [
                          _createVNode(_component_el_icon, { color: "#c83734" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Coordinate)
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" 官方网址: ")
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: "authorityInfoBody clickAuthorityInfoBody",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(clickOfficialWebsite)(_unref(collegeInfo).contact.website)))
                        }, _toDisplayString(_unref(collegeInfo).contact.website), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(collegeInfo).contact.recruitWebsite !='')
                  ? (_openBlock(), _createBlock(_component_el_form_item, { key: 1 }, {
                      label: _withCtx(() => [
                        _createElementVNode("div", _hoisted_150, [
                          _createVNode(_component_el_icon, { color: "#c83734" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Place)
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" 招生网址: ")
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: "authorityInfoBody clickAuthorityInfoBody",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(clickOfficialWebsite)(_unref(collegeInfo).contact.recruitWebsite)))
                        }, _toDisplayString(_unref(collegeInfo).contact.recruitWebsite), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(collegeInfo).contact.masterWebsite !='')
                  ? (_openBlock(), _createBlock(_component_el_form_item, { key: 2 }, {
                      label: _withCtx(() => [
                        _createElementVNode("div", _hoisted_151, [
                          _createVNode(_component_el_icon, { color: "#c83734" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Place)
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" 研招官网: ")
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: "authorityInfoBody clickAuthorityInfoBody",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(clickOfficialWebsite)(_unref(collegeInfo).contact.masterWebsite)))
                        }, _toDisplayString(_unref(collegeInfo).contact.masterWebsite), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(collegeInfo).contact.collegePhone !='')
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_unref(collegeInfo).contact.collegePhone, (item, i) => {
                      return (_openBlock(), _createBlock(_component_el_form_item, null, _createSlots({
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_153, _toDisplayString(item), 1)
                        ]),
                        _: 2
                      }, [
                        (!(i!=0 && _unref(collegeInfo).contact.collegePhone.length>1))
                          ? {
                              name: "label",
                              fn: _withCtx(() => [
                                _createElementVNode("div", _hoisted_152, [
                                  _createVNode(_component_el_icon, { color: "#c83734" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Phone)
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode(" 官方电话: ")
                                ])
                              ]),
                              key: "0"
                            }
                          : undefined
                      ]), 1024))
                    }), 256))
                  : _createCommentVNode("", true),
                (_unref(collegeInfo).contact.collegeMain !='')
                  ? (_openBlock(), _createBlock(_component_el_form_item, { key: 4 }, {
                      label: _withCtx(() => [
                        _createElementVNode("div", _hoisted_154, [
                          _createVNode(_component_el_icon, { color: "#c83734" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Message)
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" 官方邮箱: ")
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_155, _toDisplayString(_unref(collegeInfo).contact.collegeMain), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(collegeInfo).contact.collegeAddress !='')
                  ? (_openBlock(), _createBlock(_component_el_form_item, { key: 5 }, {
                      label: _withCtx(() => [
                        _createElementVNode("div", _hoisted_156, [
                          _createVNode(_component_el_icon, { color: "#c83734" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_LocationInformation)
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" 具体地址: ")
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_157, _toDisplayString(_unref(collegeInfo).contact.collegeAddress), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_158, [
        _createElementVNode("div", _hoisted_159, [
          _hoisted_160,
          _createVNode(_component_el_form, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "1." }, {
                default: _withCtx(() => [
                  _hoisted_161
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "2." }, {
                default: _withCtx(() => [
                  _hoisted_162
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "3." }, {
                default: _withCtx(() => [
                  _hoisted_163
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _hoisted_164
    ])
  ], 64))
}
}

})